export const UPDATE_PROJECT_ATTEMPT = 'UPDATE_PROJECT_ATTEMPT';
export type UPDATE_PROJECT_ATTEMPT = typeof UPDATE_PROJECT_ATTEMPT;

export const UPDATE_PROJECT_SUCCESS = 'UPDATE_PROJECT_SUCCESS';
export type UPDATE_PROJECT_SUCCESS = typeof UPDATE_PROJECT_SUCCESS;

export const UPDATE_PROJECT_FAILURE = 'UPDATE_PROJECT_FAILURE';
export type UPDATE_PROJECT_FAILURE = typeof UPDATE_PROJECT_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/project/update/Types.tsx